if (!customElements.get("swiper-slider")) {
  let swiperReady;

  // One <script> per carousel section would run the 155 KB bundle again for each section on the page.
  const loadSwiper = () =>
    (swiperReady ??= new Promise((resolve, reject) => {
      if (window.Swiper) return resolve();
      const script = document.createElement("script");
      script.src = document.querySelector('link[rel="preload"][href*="swiper-bundle.min.js"]').href;
      script.onload = resolve;
      script.onerror = reject;
      document.head.append(script);
    }));

  customElements.define(
    "swiper-slider",
    class SwiperSlider extends HTMLElement {
      connectedCallback() {
        if (this.swiper || !this.querySelector(".swiper-slide")) return;
        loadSwiper().then(
          () => this.start(),
          () => {},
        );
      }

      start() {
        if (this.swiper || !this.isConnected) return;

        const options = JSON.parse(this.dataset.options || "{}");
        const scope = this.closest(".shopify-section") || this;

        if (this.dataset.pagination) {
          options.pagination = { ...options.pagination, el: scope.querySelector(this.dataset.pagination) };
        }
        if (this.dataset.next || this.dataset.prev) {
          options.navigation = {
            nextEl: this.dataset.next ? scope.querySelector(this.dataset.next) : null,
            prevEl: this.dataset.prev ? scope.querySelector(this.dataset.prev) : null,
          };
        }

        new Swiper(this, options);
      }

      disconnectedCallback() {
        if (this.swiper) this.swiper.destroy(true, true);
      }
    },
  );
}
